export enum Contact {
    DEFAULT,
    EXTERNAL_SIGNING,
}

export enum RegistrationAction {
    NONE,
    EXTERNAL_SIGNING,
    SUBMIT,
    APPROVE_REGISTRATION,
}
